module.exports = __webpack_public_path__ + "static/media/Astromatch.9b37e9f7.png";